export enum ContactMethodTypes {
  Phone = 1,
  Email = 2,
  Fax = 3,
  Mail = 4,
  Portal = 5,
}

export const contactMethodTypes: { [key: number]: string } = {
  [ContactMethodTypes.Email]: "Email",
  [ContactMethodTypes.Fax]: "Fax",
  [ContactMethodTypes.Phone]: "Phone",
  [ContactMethodTypes.Mail]: "Mail",
  [ContactMethodTypes.Portal]: "Portal",
};

export const parsePossiblyIncorrectlySerializedContactMethodType = (
  contactMethodType: any
): ContactMethodTypes | null | undefined => {
  if (typeof contactMethodType === "number") {
    return contactMethodType;
  }

  if (!contactMethodType) {
    return null;
  }

  const found = Object.entries(contactMethodTypes).find(
    ([_key, value]) => value.toLowerCase() === contactMethodType.toLowerCase()
  );
  if (found) {
    return parseInt(found[0]);
  }

  return parseInt(contactMethodType);
};

export const contactMethodTypesOptions = Object.entries(contactMethodTypes).map(
  ([key, value]) => ({
    label: value,
    value: parseInt(key),
  })
);
